<template>
  <div
    class="features-section"
    id="features"
    data-testid="elem_u_003064"
  >
    <div
      class="dashboard-images"
      data-testid="elem_u_003065"
    >
      <img
        src="@/assets/img/home/features/img/dashboard-desktop.png"
        alt="unzipvr dashboard"
        class="desktop-image"
        data-testid="elem_u_003066"
      />
      <img
        src="@/assets/img/home/features/img/dashboard-mobile.png"
        alt="unzipvr dashboard"
        class="mobile-image"
        data-testid="elem_u_003067"
      />
    </div>
    <div
      class="description-container"
      data-testid="elem_u_003068"
    >
      <h2 data-testid="elem_u_003069">Awesome features</h2>
      <div
        class="description"
        data-testid="elem_u_003070"
      >
        Our team of dedicated affiliate professionals has went through all the trial and error in
        order to build the perfect platform with the best features ever.
      </div>
    </div>
    <ul
      class="advantages-container"
      data-testid="elem_u_003071"
    >
      <li
        class="advantage-item"
        data-testid="elem_u_003072"
      >
        <div
          class="icon-box"
          data-testid="elem_u_003073"
        >
          <v-icon
            color="#e9e9e9"
            data-testid="elem_u_003074"
          >
            support_agent
          </v-icon>
        </div>
        <span data-testid="elem_u_003075"> 27/7 Support </span>
      </li>
      <li
        class="advantage-item"
        data-testid="elem_u_003076"
      >
        <div
          class="icon-box"
          data-testid="elem_u_003077"
        >
          <v-icon
            color="#e9e9e9"
            data-testid="elem_u_003078"
          >
            auto_graph
          </v-icon>
        </div>
        <span data-testid="elem_u_003079">Exclusive Tools </span>
      </li>
      <li
        class="advantage-item"
        data-testid="elem_u_003080"
      >
        <div
          class="icon-box"
          data-testid="elem_u_003081"
        >
          <v-icon
            color="#e9e9e9"
            data-testid="elem_u_003082"
            >request_quote</v-icon
          >
        </div>
        <span data-testid="elem_u_003083">Higher Payouts</span>
      </li>
      <li
        class="advantage-item"
        data-testid="elem_u_003084"
      >
        <div
          class="icon-box"
          data-testid="elem_u_003085"
        >
          <v-icon
            color="#e9e9e9"
            data-testid="elem_u_003086"
            >local_offer</v-icon
          >
        </div>
        <span data-testid="elem_u_003087">Best conversions VR offers</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Features',
};
</script>

<style lang="scss" scoped>
.features-section {
  max-width: 1920px;
  width: 100%;
  display: grid;
  grid-template-columns: 960px auto;
  grid-template-rows: 255px auto;
  column-gap: 50px;
  row-gap: 50px;
  padding-top: 100px;
  padding-bottom: 100px;

  @media (max-width: 1600px) {
    grid-template-columns: 57.1% auto;
    grid-template-rows: auto auto;
    column-gap: 20px;
  }

  @include md-down {
    padding-top: 50px;
    padding-bottom: 50px;
  }

  @include sm-down {
    grid-template-columns: 100%;
    grid-template-rows: auto;
    row-gap: 20px;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .dashboard-images {
    position: relative;
    grid-area: 1 / 1 / 3 / 2;
    aspect-ratio: 480 / 293;

    @media (max-width: 1600px) {
      grid-area: auto;
      min-width: 416px;
      aspect-ratio: 13 / 8;
    }

    @include sm-down {
      min-width: unset;
      grid-area: 2 / 1 / 3 / 2;
      display: flex;
    }

    .desktop-image {
      width: 902px;
      border-radius: 20px;
      max-height: 507px;
      background: #313131;
      top: 5px;
      left: 5px;

      @media (max-width: 1600px) {
        width: 93.75%;
        aspect-ratio: 39 / 22;
        border-radius: 10px;
        top: 2px;
        left: 2px;
      }

      @include sm-down {
        width: calc(100% - 4px);
        align-self: flex-start;
      }
    }
    .mobile-image {
      position: absolute;
      width: 250px;
      aspect-ratio: 25 / 47;
      border-radius: 20px;
      background: #313131;
      right: -5px;
      bottom: -5px;

      @media (max-width: 1600px) {
        width: 26.1%;
        border-radius: 10px;
        right: -2px;
        bottom: -2px;
      }
    }
  }

  .description-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    color: var(--color-grey-280);
    gap: 20px;

    @media (max-width: 1600px) {
      grid-area: 1 / 1 / 2 / 3;
    }
    @include sm-down {
      grid-area: 1 / 1 / 2 / 2;
      margin-bottom: 10px;
    }

    h2 {
      padding: 0;
      margin: 0;
      font-size: 42px;
      font-weight: 700;
      line-height: 49px;

      @include md-down {
        font-size: 30px;
        line-height: 35px;
      }
      @include sm-down {
        font-size: 24px;
        line-height: 28px;
      }
    }

    .description {
      font-size: 20px;
      font-weight: 400;
      line-height: 140%;
      max-width: 463px;
      color: var(--color-grey-400);

      @media (max-width: 1600px) {
        max-width: 100%;
      }
      @include md-down {
        font-size: 16px;
        line-height: 22px;
      }
    }
  }
  .advantages-container {
    display: flex;
    flex-direction: column;
    gap: 25px;
    font-size: 18px;
    font-weight: 500;
    line-height: 21px;
    color: var(--color-grey-280);
    height: fit-content;
    padding-left: 0px;

    @media (max-width: 1600px) {
      justify-content: center;
      align-self: center;
      padding-left: 20px;
      gap: 10px;
    }

    @include sm-down {
      font-size: 16px;
      line-height: 19px;
    }

    .advantage-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 12px;
      flex-wrap: nowrap;
    }

    .icon-box {
      background: var(--color-grey-280);
      width: 26px;
      height: 26px;
      border-radius: 8px;
    }
  }
}

.features {
  background-color: var(--color-background--light);
  padding: 60px 0 123px 0;
  @media only screen and (max-width: 1540px) and (min-width: 1024px) {
    padding-bottom: 100 / 1540 * 100vw;
  }
  @include md-down {
    padding: 40px 0 67px 0;
  }
  @include sm-down {
    padding: 40px 0;
  }
  &__inner {
    display: flex;
    @include md-down {
      align-items: center;
    }
    @media only screen and (max-width: 600px) {
      flex-direction: column;
    }
  }
  &__content {
    flex: 0 0 458px;
    margin-left: 61px;
    margin-top: 136px;
    @media only screen and (max-width: 1540px) {
      margin-top: 100/1540 * 100vw;
    }
    @include lg-down {
      flex: 0 1 420px;
      margin-left: 31px;
    }
    @include md-down {
      flex: 0 1 300px;
      margin-right: 15px;
      margin-left: 24px;
      margin-top: 0;
    }
    @media only screen and (max-width: 600px) {
      flex: unset;
      width: 100%;
      margin: 35px 0px 0 0px;
      .v-list {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
  &__images {
    flex: 1 1 auto;
    position: relative;
    width: 100%;
  }
  &__image {
    &-desktop {
      width: calc(100% - 55px);
      min-height: 190px;
      @include lg-down {
        width: calc(100% - 26px);
      }
      @media only screen and (max-width: 768px) {
        max-width: 448px;
      }
      @include sm-down {
        width: calc(100% - 20px);
        border-radius: 10px;
      }
    }
    &-mobile {
      width: 26%;
      position: absolute;
      top: 116px;
      right: 0;
      min-height: 170px;
      @include md-down {
        top: 54px;
      }
      @media only screen and (max-width: 768px) {
        max-width: 122px;
      }
      @include sm-down {
        top: 74 / 768 * 100vw;
      }
    }
  }
  &__title {
    margin-bottom: 35px;
    @include lg-down {
      margin-bottom: 25px;
    }
    @include sm-down {
      margin-bottom: 12px;
    }
  }
  &__text {
    font-size: 20px;
    line-height: 28px;
    color: var(--color-grey-900-content);
    margin-bottom: 50px;
    @include lg-down {
      margin-bottom: 30px;
      font-size: 14px;
      line-height: 20px;
    }
    @include md-down {
      max-width: 458px;
    }
    @include sm-down {
      max-width: none;
      margin: 0px 0px 25px 0px;
    }
  }
  &__items {
    background-color: transparent !important;
  }
  &__item {
    &.v-list-item.theme--dark {
      color: var(--color-grey-240) !important;
    }

    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    color: var(--color-grey-240) !important;
    margin-bottom: 20px;
    min-height: 0;
    &:last-of-type {
      margin: 0;
    }
    @media only screen and (max-width: 600px) {
      &:nth-of-type(3) {
        margin: 0;
      }
    }
    @include lg-down {
      font-size: 13px;
      line-height: 15px;
    }
    @include sm-down {
      font-size: 12px;
      line-height: 14px;
      margin-bottom: 14px;
    }
    @media only screen and (max-width: 600px) {
      &:nth-child(even) {
        flex: 0 1 55%;
      }
      &:nth-child(odd) {
        flex: 0 1 45%;
      }
    }
  }
  &__icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background-color: var(--color-background);
    margin-right: 20px;
    flex-shrink: 0;
    .v-icon {
      font-size: 20px;
    }
    @include lg-down {
      width: 26px;
      height: 26px;
      margin-right: 12px;
      .v-icon {
        font-size: 14px;
      }
    }
    @include sm-down {
      width: 21px;
      height: 21px;
      border-radius: 6px;
      margin-right: 10px;
      .v-icon {
        font-size: 11px;
      }
    }
  }
}
</style>
